import { atom } from "recoil";

export const addStateOfficeType = atom({
  key: "addStateOfficeType",
  default: false,
});
export const editStateOfficeType = atom({
  key: "editStateOfficeType",
  default: false,
});
export const rowEditIdStateOfficeType = atom({
  key: "rowEditIdStateOfficeType",
  default: null,
});
export const disableButtonStateOfficeType = atom({
  key: "disableButtonStateOfficeType",
  default: false,
});

export const selectedRowsStateOfficeType = atom({
  key: "selectedRowsStateOfficeType",
  default: [],
});

export const setFilterTextOfficeType = atom({
  key: "setFilterTextOfficeType",
  default: "",
});
